import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, OnInit } from '@angular/core';
import { IEntity } from '@interfaces/entity';
import { ChargingStation } from '@models/charging-station';
import { ChargingPoint } from '@models/chargingPoint';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { FormService } from '@services/form/form.service';
import { ToastService } from '@services/toast/toast.service';
import Swal from 'sweetalert2';
import { Address } from '../../../../models/address';

@Component({
  selector: 'app-create-charging-station-assistent-dialog-content',
  templateUrl: './create-charging-station-assistent-dialog-content.component.html',
  styleUrls: ['./create-charging-station-assistent-dialog-content.component.scss']
})
export class CreateChargingStationAssistentDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'CreateChargingStationAssistentDialogContentComponent';

  public customerId: number;

  constructor(
    public activeModal: NgbActiveModal,
    public chargingStationsService: ChargingStationsService,
    public formService: FormService,
    public toastService: ToastService,
    injector: Injector
  ) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  onSubmit(formValue) {
    //console.log(formValue);
    var address = new Address();
    address.city = formValue.city;
    address.postalCode = formValue.postalCode;
    address.houseNumber = formValue.houseNumber;
    address.street = formValue.street;
    formValue.Address = address;
    formValue.location = formValue.street + " " + formValue.houseNumber + ", " + formValue.postalCode + " " + formValue.city;
    var entity = new ChargingStation(formValue);
    //console.log(entity);

    if (this.customerId) {
      this.chargingStationsService.createChargingstationForCustomer(this.customerId, entity).subscribe(data => {
        this.activeModal.close();
        this.toastService.success($localize`:@@CreateDialogSaveSuccessHeader:Ladestation erfolgreich gespeichert.`);
      }, error => {});

    } else {
      this.chargingStationsService.createEntity(entity).subscribe(data => {
        this.activeModal.close();
        this.toastService.success($localize`:@@CreateDialogSaveSuccessHeader:Ladestation erfolgreich gespeichert.`);
      }, error => {});
    }
  }

  newEntityEvent(entity: IEntity) {
    this.activeModal.close();
  }

  onCancelClick() {
    this.activeModal.close();
  }
}
